export default {
  // 风险评估
  assessment: {
    entry: {
      pageTitle: "風險承受能力測評",
      riskText: "測壹測您的風險承受能力有多少",
      btnText: "開始測評"
    },
    question: {
      pageTitle: "風險承受能力問卷",
      btnText: "提交測評",
      titleText: "請按照您實際情況選擇",
      titleMark: "*號必填",
      derivative_clew: "與身份證件不一致，請確認",
      derivative_clew_two: "與適當性調查不一致，請確認",
      question: [
        {
          id: 1,
          title: "您的年齡介乎於？",
          isMust: true,
          choices: [
            {
              text: "(a) 18 ~ 35 周歲之間",
              name: "a"
            },
            {
              text: "(b) 36 ~ 44 周歲之間",
              name: "b"
            },
            {
              text: "(c) 44 ~ 55 周歲之間",
              name: "c"
            },
            {
              text: "(d) 55 ~ 65 周歲之間",
              name: "d"
            },
            {
              text: "(e) >65 周歲",
              name: "e"
            }
          ]
        },
        {
          id: 2,
          title: "您的敎育程度是？",
          isMust: true,
          choices: [
            {
              text: "(a) 小學程度",
              name: "a"
            },
            {
              text: "(b) 中學程度",
              name: "b"
            },
            {
              text: "(c)  預科",
              name: "c"
            },
            {
              text: "(d) 大學程度",
              name: "d"
            }
          ]
        },
        {
          id: 3,
          title:
            "您是否有以下任何產品的投資經驗或知識？(您可選擇多於一個選項)？",
          isMust: true,
          isCheck: true,
          ref: "checkBoxRef1",
          choices: [
            {
              text:
                "(a) 現金、存款、存款證、保本產品、香港政府債券、強積金、貨幣市場基金",
              name: "a"
            },
            {
              text:
                "(b) 股票、債券、股票或債券基金(包括強積金，不包括貨幣市場基金)、投資相連保單",
              name: "b"
            },
            {
              text:
                "(c) 衍生工具（如：期權、期貨、認股權證(俗稱「窩輪」))、對沖基金、結構性產品（如：累計認購期權、股票掛鈎票據）",
              name: "c"
            }
          ]
        },
        {
          id: 4,
          title:
            "您有多少年投資於以下價值波動之投資產品(包括外幣商品、結構投資產品、認股權證(俗稱「窩輪」)、期權、期貨)的經驗，例如購入然後長期持有或經常買賣投資產品？",
          isMust: true,
          choices: [
            {
              text: "(a) 没有經驗",
              name: "a"
            },
            {
              text: "(b) 少過1年",
              name: "b"
            },
            {
              text: "(c) 1至3年",
              name: "c"
            },
            {
              text: "(d) 多過3年",
              name: "d"
            }
          ]
        },
        {
          id: 5,
          title:
            "您有多少年投資於以下價值波動之投資產品(包括股票、單位信託基金、債券、投資相連保單等)的經驗(例如購入然後長期持有或經常買賣投資產品？",
          isMust: true,
          choices: [
            {
              text: "(a) 没有經驗",
              name: "a"
            },
            {
              text: "(b) 少過1年",
              name: "b"
            },
            {
              text: "(c) 1至3年",
              name: "c"
            },
            {
              text: "(d) 多過3年",
              name: "d"
            }
          ]
        },
        {
          id: 6,
          preTitle:
            "在一段時間之內，投資價值可升可跌，我們稱之為波動。一般而言，風險愈高的投資，其潛在波動愈大，但潛在回報亦愈高。相反，風險愈低的投資，其潛在波動愈小，但潛在回報亦相對較低。",
          title: "在一般情況下，您會願意投資於波動程度多大的投資產品？",
          isMust: true,
          choices: [
            {
              text: "(a) 波動多於 -30% 至 +30%",
              name: "a"
            },
            {
              text: "(b) 波動於 -25% 至 +25%",
              name: "b"
            },
            {
              text: "(c)  波動於 -15 至 +15% 之間",
              name: "c"
            },
            {
              text: "(d) 波動於 -5 至 +5% 之間",
              name: "d"
            }
          ]
        },
        {
          id: 7,
          title:
            "您打算用作於高盈證券投資的資金佔流動資產淨值（不包括自住物業）的百分比是多少？",
          isMust: true,
          choices: [
            {
              text: "(a) 少於10%",
              name: "a"
            },
            {
              text: "(b) 10% ~ 40%",
              name: "b"
            },
            {
              text: "(c) 40% ~ 60%",
              name: "c"
            },
            {
              text: "(d) 60%或以上",
              name: "d"
            }
          ]
        },
        {
          id: 8,
          title: "您有多需要將投資項目變現，來滿足對突發事件的流動資金需要？",
          isMust: true,
          choices: [
            {
              text: "(a)  我不一定會出售任何投資",
              name: "a"
            },
            {
              text: "(b) 我會出售不多於30%的投資",
              name: "b"
            },
            {
              text: "(c) 我會出售多於30%但不於50%的投資",
              name: "c"
            },
            {
              text: "(d) 我會出售50%以上的投資",
              name: "d"
            }
          ]
        },
        {
          id: 9,
          preTitle:
            "在一般情況下，投資的年期越長，可承受的風險越高，而投資產品的價值亦會波動。",
          title: "當投資於產品時，您會願意接受下列哪項投資年期？",
          posTitle: "有關投資產品的例子，請參閱問題3",
          isMust: true,
          choices: [
            {
              text: "(a) 多過5年",
              name: "a"
            },
            {
              text: "(b) 3年至5年",
              name: "b"
            },
            {
              text: "(c) 1至3年",
              name: "c"
            },
            {
              text: "(d) 少過1年",
              name: "d"
            }
          ]
        },
        {
          id: 10,
          title: "以下哪項描述最適合形容您的投資目標？",
          isMust: true,
          choices: [
            {
              text:
                "(a) 防守—希望保障我的資本及獲得稍微高於存款的投資回報。我可承受低程度的資本損失。",
              name: "a"
            },
            {
              text:
                "(b) 收入—希望於定期收入及資本增長之間取得平衡，並可承受中等程度的資本損失。",
              name: "b"
            },
            {
              text:
                "(c) 資本增值—我以長線資本增值為目標，並可承受大額度的資本損失。",
              name: "c"
            },
            {
              text:
                "(d) 進取—我只尋求資本增值，同時可承受大幅度的資本價格波動。我願意為了高回報而冒較高風險。",
              name: "d"
            }
          ]
        }
      ],
      toastMsg: "請根據您的實際情況選擇"
    },
    result: {
      pageTitle: "風險承受能力測評",
      domText: [
        "您的得分是",
        "分",
        "總分100分",
        "您屬於",
        "投資者",
        "風險承受程度:",
        "確定",
        "重新測評",
        "免責與客戶聲明",
        "請閱讀完畢下述聲明並在彈窗底部點擊按鈕",
        "我已閱讀免責聲明並同意客戶聲明",
        "不同意"
      ],
      textContent: [
        {
          title: "免責聲明",
          content: [
            "1. 本問卷的結果是從您向高盈證券有限公司提供的資料，並根據若干普遍接納的假設及合理估算而得出。本問卷採用的方法及取值僅供說明用途，本集團對本問卷所載資料及/或所得結果的準確性或完整性並不負責或承擔任何法律責任。",
            "2. 本問卷及所得結果僅供您參考，並非購買或出售任何金融產品及服務的要約或招攬，亦不應被視為投資意見或推薦。",
            "3. 請注意，倘若您未能全面披露所有或任何有關您的個人狀況（如財務狀況）、不正確、不完整或過時的資料可能影響本集團評估您對投資風險的態度及承受能力。如您的狀況出現變動而可能影響本問卷中任何問題的答案，我們極力建議您再次填寫本問卷。"
          ]
        },
        {
          title: "客戶聲明",
          content: [
            "本人（等）謹此聲明：本人（等）為本問卷所提供資料為真實、正確及全面，並同意上述的投資風險承受能力分析為正確。"
          ]
        }
      ]
    }
  },
  // 资金管理
  funds: {
    pageTitle: [
      "資金帳戶",
      "帳戶資金詳情",
      "轉入資金",
      "匯款對照信息",
      "上傳匯款憑證",
      "訂單詳情",
	  "資金帳戶列表",
      "資金劃轉記錄",
	  "資金劃轉"
    ],
    copy: '帳號複製成功',
    copyFail: '帳號複製失敗',
    domText: [
      "標準合約A帳戶",
      "連續合約B帳戶",
      "折算",
      "幣種",
      "可轉出金額合計",
      "可轉出資金",
      "帳戶總金額",
      "帳戶余額",
      "我的銀行卡",
      "資金記錄",
      "資金流水",
      '折算币种'
    ],
	accountName:["期貨帳戶","證券帳戶"],
    jsText: ["已綁定", "未綁定"],
    btnText: ["轉入", "轉出", "換匯", "帳戶詳情"],
    currencyText: ["美元", "港幣", "人民幣"],
    orderDetail: {
      domText: ["轉帳憑證", "備註", "處理失敗退款"],
      fieldsText: [
        "訂單編號",
        "資金帳戶",
        "訂單類型",
        "方式",
        "處理結果",
        "轉入幣種",
        "轉出幣種",
        "轉入金額",
        "轉出金額",
        "轉入時間",
        "轉出時間",
        "手續費",
        "到帳金額",
        "預計到帳",
        "到帳時間"
      ],
      otherText: ["付款幣種", "付款金額", "付款時間"],
      payText: ["匯款", "劃轉", "錄入", "換匯", "資訊訂單"]
    },
    fundsDetail: {
      domText: "更新時間",
      fieldsText: [
        "帳戶名",
        "帳戶類型",
        "帳戶資金",
        "美元帳戶",
        "美元帳戶可用資金",
        "港幣帳戶",
        "港幣帳戶可用資金",
        "人民幣帳戶",
        "人民幣帳戶可用資金"
      ]
    },
    into: {
      domText: [
        "我持有的銀行卡",
        "請不要使用他人銀行帳戶匯款，匯款人與期貨帳戶持有人必須是同壹人",
        "註意根據香港證監會要求，匯款人和證券期貨帳戶持有人必須是同壹人，匯款銀行帳戶的姓名必須與您的高盈國際（香港）帳戶姓名相同，不可使用他人姓名的銀行帳戶匯款。",
        "第壹步：準備港幣/美元",
        "請確保您的銀行帳戶擁有港幣/美元，您可以通過網上銀行或手機銀行兌換成港幣/美元(各銀行貨幣兌換業務資費和營業時間不同，請聯系兌換銀行確認)",
        "第二步: 轉入港幣/美元",
        "請將款項匯入下方指定的銀行帳戶，推薦使用中國銀行、工商銀行、華夏銀行進行匯款，到帳成功率高。大陸的招商銀行、交通銀行、建設銀行暫時不能使用，轉帳不能到帳，銀行匯款會失敗被原路退回。",
        "為保障您的資金安全，匯款後請立刻",
        "截屏並上傳匯款憑證",
        "手機銀行轉帳時請將帶有具體匯款金額的1個或多個頁面截圖上傳，憑證需包含匯款金額、匯款人姓名、收款人帳號、收款人姓名",
        "請匯款至您的工銀亞洲資金托管帳戶",
        "在您的姓名拼音前加上“GoingInternational”，均為大寫字母",
        "您的資金托管帳戶默認為加密隱藏，查看請點擊按鈕",
        " 請選擇匯款銀行",
        "入金指南",
        "按照下列信息填寫匯款單",
        "手續費，同行免費",
        "到帳時間：預計1~3個工作日內"
      ],
      bankList: [
        "大陸地區銀行卡",
        "香港地區銀行卡",
        "支持：港元、美元",
        "支持：港元、美元、人民幣"
      ],
      fieldsText: [
        "收款人名稱",
        "收款帳戶",
        "國家/地區",
        "收款人地址",
        "收款銀行 （中文）",
        "收款銀行 （英文）",
        "銀行地址",
        "銀行名稱",
        "帳戶名稱",
        "收款帳號（港幣）",
        "收款帳號（美元）",
        "收款帳號（人民幣）"
      ],
      others: [
        "復制",
        "查看",
        "我已匯款,上傳憑證",
        "申請成功",
        "知道了",
        "您的申請已收到，我們將在1個工作日內處理",
        "復制成功"
      ],
      tips: [
        "註意：",
        "為保障您的資金安全匯款後請立刻截屏並上傳匯款憑證；",
        "手機銀行轉帳時請將帶有具體匯款金額的1個或多個頁面截圖上傳；",
        "憑證需要包含匯款金額、匯款人姓名、收款人帳號、收款人姓名",
        "提示：請根據實際情況提供相關憑證，有助於我們給您提供更好的服務和體驗"
      ]
    },
    credential: {
      domText: [
        "填寫並上傳匯款憑證",
        "提交",
        "人民幣（離岸）",
        "請輸入金額，並保留2位小數",
        "上傳中",
        "資金轉入訂單提交成功",
        "預計到帳時間1-3個工作日",
        "知道了"
      ],
      fields: ["匯款幣種", "存入金額", "上傳憑證", "請上傳所選項的相關憑證"]
    },
    transferRecord:{
      domText:['取消訂單','請輸入交易密碼','忘記交易密碼？','是否取消資金劃轉訂單？','請輸入交易密碼','該訂單取消成功','溫馨提示','暫不取消','確定','驗證交易密碼'],
      fields:['待處理','處理成功','處理失敗','訂單取消']
    }
  },
  // 银行卡
  bankCard: {
    pageTitle: ["我的銀行卡", "綁定銀行卡"],
    domText: [
      "綁定銀行卡",
      "解除綁定",
      "修改銀行卡",
      "取消",
      "提示",
      "將銀行卡解除綁定？",
      "注意：請務必綁定帳戶持有人同名銀行卡",
      "下壹步",
      "請先完成開戶",
      "修改成功",
      "添加成功",
      "持有人",
      "銀行帳號憑證",
      "說明：請上傳含持有人姓名和銀行帳號的銀行卡或者結單"
    ],
    fields: ["銀行名稱", "銀行帳號", "支持的幣種(可多選)"],
    placeholderText: [
      "請輸入銀行全稱",
      "請輸入",
      "如有，請填寫",
      "例如中國銀行(總行)BKCHCNBJXXX"
    ],
    btnText: '提交',
    accountTipText: "賬戶號碼說明",
    bankNamePlaceholder: "請填寫銀行名稱"
  },
  // 公告
  notice: {
    pageTitle: "公告",
    noticePublicText: "發布時間",
    domText: "公告無內容",
    loadingText: "PDF下載中"
  },
  // 隐私政策
  policy: {
    pageTitle: "個人資料(私隱)政策/私隱政策聲明"
  },
  // 组件
  myComponent: {
    domText: "處理失敗退款",
    typeText: ["轉入", "轉出", "付款"],
    statusText: ["待處理", "處理成功", "處理失敗", "自動處理", "退款到帳","已取消"],
    accountTypeText: ["A帳戶", "B帳戶"],
	dialogBtText:["暫不取消","確認"],
	dialogText:"是否取消出金訂單？",
  dialogText1:"是否取消入金訂單？",
	cancelBtn:"取消訂單"
  },
  // 公共
  public: {
    contentText: [
      "没有更多了",
      "暫無數據",
      "參數錯誤",
      "請選擇",
      "加載中",
      "加載失敗，點擊屏幕重試",
      "數據加載失敗，點擊",
      "重新加載"
    ]
  },
  poorNetwork: "當前網絡不穩定，數據更新可能會延遲"
};
